import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import i18n from './i18n';
import * as serviceWorker from './serviceWorker';
import { I18nextProvider } from 'react-i18next';
import { Amplify } from 'aws-amplify'
import AmplifyConfiguration from './util/AmplifyConfiguration'
import NadheoEmbeddedPlaceMap from './NadheoEmbeddedPlaceMap'

Amplify.configure(AmplifyConfiguration);

const elements = document.getElementsByClassName('nadheo-placemap');
for (const elem of elements) {
  console.log("Element found ");
  let show = "";
  let place = "";
  let startTime = "";
  const attributes = elem.attributes;
  for (let i=0; i < attributes.length; i++) {
    switch (attributes.item(i).name) {
      case "show": show = attributes.item(i).value; break;
      case "place": place = attributes.item(i).value; break;
      case "start_time": startTime = attributes.item(i).value; break;
      default: break;
    }
  }
  ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback="Waiting translations">
        <I18nextProvider i18n={i18n}>
          <NadheoEmbeddedPlaceMap show={show} place={place} startTime={startTime}/>
        </I18nextProvider>
      </Suspense>
    </React.StrictMode>,
    elem
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
